import { DetailedHTMLProps, ImgHTMLAttributes, useState } from 'react'

import { useUpdateEffect } from 'ahooks'
import { Skeleton } from 'antd'

export const ImageCardImg = ({
  src,
  width = 120,
  alt,
  ...restProps
}: DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>) => {
  const [failed, setFailed] = useState(false)

  const handleError = () => {
    setFailed(true)
  }

  useUpdateEffect(() => {
    setFailed(false)
  }, [src])

  return failed ? (
    <Skeleton.Image />
  ) : (
    <img
      {...restProps}
      alt={alt}
      id='test'
      src={src}
      width={width}
      onError={handleError}
    />
  )
}
